import { useMemo } from "react";

import type { HotelNotificationSettingQueryQuery } from "@/lib/gql/__generated__/graphql";

import * as FormModel from "@/components/features/hotel-notification-settings/model";
import type * as FormModelType from "@/components/features/hotel-notification-settings/model/type";

import * as UseCase from "../use-update-hotel-notification-settings";
import * as Converter from "./converter";

type Props = {
	data: HotelNotificationSettingQueryQuery;
};

export const useInitialized = ({ data }: Props) => {
	const initInputModel: FormModelType.HotelNotificationSettingFormModel["InputModel"] = useMemo(
		() => Converter.serverModelToInputModelConverter(data),
		[data],
	);

	const queryData: FormModelType.HotelNotificationSettingFormModel["QueryData"] = useMemo(
		() => data.hotelNotificationSetting,
		[data],
	);

	const { inputModel, viewModel, onSetViewModel, onResetViewModel } =
		FormModel.useHotelNotificationSettingFormModel(initInputModel);

	const { onUpdateHotelNotificationSettings } = UseCase.useUpdateHotelSettings({ inputModel, onResetViewModel });

	return {
		queryData,
		viewModel,
		onSetViewModel,
		onUpdateHotelNotificationSettings,
	};
};
